import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { signIn } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", { session_id: sid })
      .then(async ({ data }) => { await signIn(data); nav("/", { replace: true }); })
      .catch((e) => { toast.error(errMsg(e)); nav("/login", { replace: true }); });
  }, [location.hash, nav, signIn]);

  return <div className="min-h-screen bg-slate-900" />;
}
